'use client';

import { VoteType } from '@prisma/client';
import { useCallback } from 'react';
import { Comment, ICommentable } from '../../../../types/shared';
import { UniversalCommentsSection } from './UniversalCommentsSection';
import { UniversalVoteButtons } from './UniversalVoteButtons';

type ModalContentProps<TVote, TComment> = {
  details: ICommentable<TVote, TComment>;
  itemType: 'place' | 'suggestion';
  scrollToCommentId?: string | null;

  likes: number;
  dislikes: number;
  myVote: VoteType | null;
  onVote: (voteType: VoteType) => void;
};

export function ModalContent<
  TVote extends { type: VoteType; userId: string },
  TComment extends Comment,
>({
  details,
  itemType,
  scrollToCommentId,
  likes,
  dislikes,
  myVote,
  onVote,
}: ModalContentProps<TVote, TComment>) {
  const handleVote = useCallback((voteType: VoteType) => onVote(voteType), [onVote]);

  return (
    <>
      <div className="pb-3 sm:pb-4 border-b border-slate-700">
        <div className="flex">
          <UniversalVoteButtons
            votes={details.votes} // fallback можно оставить
            likes={likes}
            dislikes={dislikes}
            onVote={handleVote}
            myVote={myVote} // ✅ источник истины
            variant="modal"
          />
        </div>
      </div>

      <div className="pt-3 sm:pt-4">
        <UniversalCommentsSection
          itemId={details.id}
          initialComments={details.comments}
          itemType={itemType}
          scrollToCommentId={scrollToCommentId}
        />
      </div>
    </>
  );
}
